<template>
  <div v-loading="loadingDataBoolean" class="checkLabel2d" element-loading-text="问题数据获取中...">
    <el-table ref="multipleTable" height="100%" :data="tabData" highlight-current-row
      class="is-grey" size="small" row-key="questionId" header-cell-class-name="table-header" style="width: 100%"
      border @selection-change="handleSelectionChange" @row-click="openDetails"
      @row-dblclick="handelRowDblclick" @filter-change="handleFilterChange">
      <el-table-column type="selection" align="center" width="50" :reserve-selection="true"></el-table-column>
      <el-table-column show-overflow-tooltip prop="fileName" width="250" label="文件名称" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="checkContent" width="300" label="问题描述" align="center">
      </el-table-column>
      <el-table-column show-overflow-tooltip :filters="filtrate.statusList" prop="queStatus" label="问题状态" width="100" align="center"
        column-key="statusList">
        <template slot-scope="scope">
          <div style="cursor:pointer" @click.stop="closePopover(scope.row.questionId)">
            <el-popover :key="scope.row.questionId" :ref="`popover${scope.row.questionId}`" placement="bottom"
              width="300" trigger="manual">
              <el-form :ref="`formstatus${scope.row.questionId}`" :rules="statusRules" :model="formstatus" class="statusForm"
                size="small" label-position="top">
                <el-form-item label="问题状态:" prop="statusId">
                  <el-select v-model="formstatus.statusId" size="small" placeholder="请选择">
                    <el-option v-for="item in dicData.dealList" :key="item.id" :label="item.cnName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="说明:">
                  <el-input v-model="formstatus.content" placeholder="请输入说明" type="textarea" maxlength="200"
                    show-word-limit></el-input>
                </el-form-item>
                <el-form-item class="footer">
                  <el-button size="small" @click="closepop(scope.row.questionId)">取 消</el-button>
                  <el-button size="small" type="primary" @click="changeStatus(scope.row)">确 定</el-button>
                </el-form-item>
              </el-form>
              <div slot="reference" class="statusChange">
                <p v-if="statusDealList.length&&scope.row.queStatusId === statusDealList[0].id" class="status"
                  style="background:#FCE9DF;color:#eb5757" @click="dealStatus(scope.row)">
                  {{ scope.row.queStatus }}
                </p>
                <p v-if="statusDealList.length&&scope.row.queStatusId === statusDealList[1].id" class="status"
                  style="background:#FFFFDF;color:#eac100;height:24px" @click="dealStatus(scope.row)">
                  {{ scope.row.queStatus }}
                </p>
                <p v-if="statusDealList.length&&scope.row.queStatusId === statusDealList[2].id" class="status"
                  style="background:#F2F2F2;color:#8b8888;height:24px" @click="dealStatus(scope.row)">
                  {{ scope.row.queStatus }}
                </p>
                <p v-if="statusDealList.length&&scope.row.queStatusId === statusDealList[3].id" class="status"
                  style="background:#DEF6E4;color:#00B632;height:24px" @click="dealStatus(scope.row)">
                  {{ scope.row.queStatus }}
                </p>
              </div>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip :filters="filtrate.severityLevelList" prop="problemType" width="100" label="严重等级"
        align="center" column-key="severityLevelList"></el-table-column>
      <el-table-column show-overflow-tooltip prop="modifierName" label="修改人" align="center" column-key="modifierList">
        <template slot-scope="scope">
          <span>{{ modifierNames(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip :filters="filtrate.checkTypeList" prop="qmType" width="100" label="意见类型" align="center"
        column-key="checkTypeList"></el-table-column>
      <el-table-column v-if="!hideSubitem" show-overflow-tooltip :filters="filtrate.subItemList"
        prop="stageChildName" :label="$titles.child" align="center" column-key="subItemList"></el-table-column>
      <el-table-column show-overflow-tooltip :filters="filtrate.specList" prop="specName" label="专业" align="center"
        column-key="specList"></el-table-column>

      <el-table-column show-overflow-tooltip prop="creatorName" label="创建人" align="center" column-key="createUserList">
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" label="创建时间" align="center" width="130"></el-table-column>
      <el-table-column show-overflow-tooltip :filters="filtrate.problemSourceList" prop="source" label="问题来源"
        align="center" column-key="problemSourceList" width="100"></el-table-column>
    </el-table>
    <div class="page">
      <page v-show="page.totalCount > 0" :page="page" style="float:right;"
        @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData"></page>
    </div>
  </div>
</template>

<script>
const filterParams = () => ({
  checkTypeList: [], // 意见类型
  createUserList: [], // 创建人
  modifierList: [], // 修改人
  problemSourceList: [], // 问题来源
  severityLevelList: [], //	严重等级
  specList: [], // 文件专业
  specStageChildVos: [], // 专业、阶段、子项
  stageList: [], //	阶段
  statusList: [], // 问题状态
  subItemList: [] // 子项
});
import requestIssueMg from "@/CommonDP/service/question-service";
import page from "@/CommonDP/components/paging";
import { mapState } from "vuex";
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  components: { page },
  props: ["searchFileName", "typeArray"],
  data() {
    return {
      hideSubitem: false,
      dataRow: "",
      loadingDataBoolean: false,
      prjID: "",
      tabData: [],
      multipleSelection: [], // 选中的数据
      clickTimeId: "",
      filtrate: filterParams(),
      selectForm: {
        statusIdList: [], // 问题状态
        problemTypeIdList: [], // 严重等级
        modifierIdList: [], // 修改人
        qmTypeIdList: [], // 意见类型
        specIdList: [], // 专业类型
        stageChildIdList: [], // 子项
        createUserIdList: [], // 创建人
        sourceList: [] // 问题来源
      },
      popover: {},
      page: {
        totalCount: 0,
        pageNum: 1, // 当前页
        pageSize: 20 // 每页限制条数
      },
      formstatus: {
        // 修改问题状态
        statusId: "", // 问题id
        content: ""
      },
      statusRules: {
        statusId: [{ required: true, message: "问题状态不可为空", trigger: "change" }]
      },
      dicData: {
        statusList: [],
        dealList: []
      }
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      messageInfo: (state) => state.XtDesign.messageObj,
      userId: (state) => state.user.userId
    }),
    statusDealList() {
      return this.dicData?.statusList || [];
    },
    searchParams() {
      const { statusIdList, problemTypeIdList, modifierIdList, qmTypeIdList, specIdList, stageChildIdList, createUserIdList, sourceList } = this.selectForm;
      const params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        prjId: this.prjID,
        keyword: this.searchFileName,
        sortType: "1", // sortType=0升序 sortType=1降序
        fileTypeList: this.typeArray,
        statusIdList,
        problemTypeIdList,
        modifierIdList,
        qmTypeIdList,
        specIdList,
        stageChildIdList,
        createUserIdList,
        sourceList
      };
      return params;
    },
    statusParams() {
      const { statusId, content } = this.formstatus;
      const { questionId, queStatusId, queStatus } = this.dataRow;
      const params = {
        content,
        prjId: this.prjID,
        idList: [questionId],
        statusId: queStatusId,
        statusName: queStatus,
        toStatusId: statusId,
        toStatusName: this.dicData.statusList.find((ele) => ele.id === statusId).cnName
      };
      return params;
    }
  },
  watch: {
    prjInfo: {
      deep: true,
      handler: function ({ prjId }, oldValue) {
        if (prjId) {
          this.prjID = prjId;
          this.getInit();
        }
      }
    },
    // 筛选修改人和创建人
    "selectForm.modifierIdList": {
      handler() {
        this.queryEvent();
      }
    },
    "selectForm.createUserIdList": {
      handler() {
        this.queryEvent();
      }
    }
  },
  created() {
    this.prjID = this.prjInfo.prjId;
    this.hideSubitem = globalParams.get("project.issue.subitem");
  },
  mounted() {
    this.getInit();
  },
  methods: {
    async dealStatus(row) {
      const { creatorId, queStatus, questionId, modifierList } = row;
      this.formstatus.statusId = "";
      this.formstatus.content = "";
      this.$refs[`popover${questionId}`].showPopper = true;
      await this.$nextTick(() => {});
      this.$refs[`formstatus${questionId}`].clearValidate();
      if (creatorId === this.userId && modifierList.some((ele) => ele.modifierId === this.userId)) {
        // 同一个人
        if (queStatus === "待修改") {
          this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "已修改" || ele.cnName === "已取消");
        } else if (queStatus === "已修改") {
          this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "已复核" || ele.cnName === "待修改" || ele.cnName === "已取消");
        } else if (queStatus === "已复核") {
          this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "待修改" || ele.cnName === "已取消");
        } else if (queStatus === "已取消") {
          this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "待修改");
        }
      } else {
        // 创建人
        if (creatorId === this.userId) {
          if (queStatus === "待修改") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "已取消");
          } else if (queStatus === "已修改") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "已复核" || ele.cnName === "待修改" || ele.cnName === "已取消");
          } else if (queStatus === "已复核") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "待修改" || ele.cnName === "已取消");
          } else if (queStatus === "已取消") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "待修改");
          }
        } else if (modifierList.some((ele) => ele.modifierId === this.userId)) {
          // 处理人
          if (queStatus === "待修改") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "已修改" || ele.cnName === "已取消");
          } else if (queStatus === "已修改") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "待修改" || ele.cnName === "已取消");
          } else if (queStatus === "已复核") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "已取消");
          } else if (queStatus === "已取消") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName === "待修改");
          }
        } else {
          this.$refs[`popover${questionId}`].showPopper = false;
          this.$message.warning("很抱歉,仅问题创建人或者问题处理人有修改问题状态的权限");
        }
      }
    },
    modifierNames(row) {
      const names = [];
      if (row.modifierList && row.modifierList.length > 0) {
        row.modifierList.forEach((ele) => {
          names.push(ele.modifierName);
        });
      }
      return names.join(",");
    },
    getInit() {
      this.loadingDataBoolean = true;
      this.page.pageNum = 1;
      this.$refs.multipleTable.clearSelection();
      this.queQuestionSearchList(); // 表头筛选数据
      this.queryEvent();
    },
    getInitOld() {
      this.loadingDataBoolean = true;
      this.queQuestionSearchList(); // 表头筛选数据
      this.queryEvent();
    },
    // 表头筛选数据
    async queQuestionSearchList() {
      const res = await requestIssueMg.getDrawingQuestionSearchList(this.prjID);
      this.filtrate = filterParams();
      if (res.result === "0") {
        const { checkTypeList, createUserList, modifierList, problemSourceList, severityLevelList, specStageChildVos, statusList } = res.data;
        this.dicData.statusList = statusList;
        // 意见类型
        if (!!checkTypeList && checkTypeList.length > 0) {
          checkTypeList.forEach((element) => {
            this.filtrate.checkTypeList.push({
              text: element.cnName,
              value: element.id
            });
          });
        }
        // 创建人
        if (!!createUserList && createUserList.length > 0) {
          createUserList.forEach((element) => {
            this.filtrate.createUserList.push({
              text: element.name,
              value: element.userId
            });
          });
        }
        // 修改人
        if (!!modifierList && modifierList.length > 0) {
          modifierList.forEach((element) => {
            this.filtrate.modifierList.push({
              text: element.name,
              value: element.userId
            });
          });
        }
        const personObject = { modifierList: this.filtrate.modifierList, createrList: this.filtrate.createUserList };
        this.$emit("setPersonDic", personObject);
        // 问题来源
        if (!!problemSourceList && problemSourceList.length > 0) {
          problemSourceList.forEach((element) => {
            this.filtrate.problemSourceList.push({
              text: element.cnName,
              value: element.cnName
            });
          });
        }
        // 严重等级
        if (!!severityLevelList && severityLevelList.length > 0) {
          severityLevelList.forEach((element) => {
            this.filtrate.severityLevelList.push({
              text: element.cnName,
              value: element.id
            });
          });
        }
        // 专业、阶段、子项
        if (!!specStageChildVos && specStageChildVos.length > 0) {
          specStageChildVos.forEach((element) => {
            if (element.id === "stage") {
              // 阶段
              element.optionalValues.forEach((ele) => {
                this.filtrate.stageList.push({
                  text: ele.cnName,
                  value: ele.id
                });
              });
            } else if (element.id === "spec") {
              // 专业
              element.optionalValues.forEach((ele) => {
                this.filtrate.specList.push({
                  text: ele.cnName,
                  value: ele.id
                });
              });
            } else if (element.id === "child") {
              // 子项
              element.optionalValues.forEach((ele) => {
                this.filtrate.subItemList.push({
                  text: ele.cnName,
                  value: ele.id
                });
              });
            }
          });
        }
        // 问题状态
        if (!!statusList && statusList.length > 0) {
          statusList.forEach((element) => {
            this.filtrate.statusList.push({
              text: element.cnName,
              value: element.id
            });
          });
        }
        // console.log(this.filtrate);
        // debugger
      }
    },
    // 当前单页数量
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNum = 1;
      this.queryEvent();
    },
    // 分页
    fetchData(val) {
      this.page.pageNum = val;
      this.queryEvent();
    },
    refresh() {
      this.queryEvent();
    },
    // 查询表格
    async queryEvent() {
      this.tabData = [];
      const res = await requestIssueMg.getDrawingQuestionPageList(this.searchParams);
      if (res.result === "0") {
        this.tabData = res.data || [];
        this.$emit("closeRight");
        this.loadingDataBoolean = false;
        this.page.pageNum = res.pageIndex;
        this.page.totalCount = res.totalCount;
        this.page.pageSize = res.pageSize;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("checkData", val);
    },
    // 行单击事件
    openDetails(row) {
      clearTimeout(this.clickTimeId);
      this.clickTimeId = setTimeout(() => {
        this.$emit("openDetail", row, "2D");
      }, 300);
    },
    // 行双击事件
    handelRowDblclick(row) {
      clearTimeout(this.clickTimeId);

      this.$refs.multipleTable.toggleRowSelection(row);
    },
    handleFilterChange(filters) {
      // 问题状态
      if (filters.statusList) {
        this.selectForm.statusIdList = filters.statusList;
      }
      // 严重等级
      if (filters.severityLevelList) {
        this.selectForm.problemTypeIdList = filters.severityLevelList;
      }
      // 修改人
      if (filters.modifierList) {
        this.selectForm.modifierIdList = filters.modifierList;
      }
      // 意见类型
      if (filters.checkTypeList) {
        this.selectForm.qmTypeIdList = filters.checkTypeList;
      }
      // 专业类型
      if (filters.specList) {
        this.selectForm.specIdList = filters.specList;
      }
      // 子项
      if (filters.subItemList) {
        this.selectForm.stageChildIdList = filters.subItemList;
      }
      // 创建人
      if (filters.createUserList) {
        this.selectForm.createUserIdList = filters.createUserList;
      }
      // 问题来源
      if (filters.problemSourceList) {
        this.selectForm.sourceList = filters.problemSourceList;
      }
      console.log(filters, "filters");
      this.page.pageNum = 1;
      this.queryEvent();
    },
    closePopover(questionId) {
      this.tabData.forEach(item => {
        if (item.questionId !== questionId) {
          this.closepop(item.questionId);
        }
      });
    },
    closepop(id) {
      this.$refs[`popover${id}`].showPopper = false;
    },
    async changeStatus(row) {
      this.dataRow = row;
      this.$refs['formstatus' + row.questionId].validate(async (valid) => {
        if (valid) {
          try {
            const res = await requestIssueMg.drawingannotationupdateStatus(this.statusParams);
            if (res.result === "0") {
              this.$message.success("修改成功");
              this.$refs[`popover${row.questionId}`].showPopper = false;
              this.queryEvent();
              this.isRead = true;
            }
          } catch (error) {
            this.$refs[`popover${row.questionId}`].showPopper = false;
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.checkLabel2d {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 var(--big-space);
  box-sizing: border-box;
  .statusChange {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .status {
    border-radius: 4px;
    max-width: 88px;
    padding: 0 15px;
    cursor: pointer;
  }
  .el-table{
    height: 1px !important;
    flex-grow: 1;
  }
  .page {
    float: right;
    padding: var(--middle-space) 0;
  }
}
</style>
